import OrderService from 'src/common/api/order.service';
import { LocalStorage, uid } from 'quasar';

export async function postOrder({ commit }, payload) {
  const response = await OrderService.post(payload);
  if (response.status === 200) {
    await commit('flush');
    await commit('updatePreviousOrder', { previousOrder: response.data.data });
  }
}

export async function postOrderForWaiter(context, payload) {
  await OrderService.post(payload);
}

export async function addCurrentProduct({ commit, dispatch, rootState }) {
  if (rootState.product.current) {
    const product = rootState.product.current;
    product.uid = uid();
    commit('addProduct', { product });
    commit('product/updateCurrentProduct', { product }, { root: true });
    await dispatch('updateTotalPrice');
  }
}

export async function addDrinksProduct({ commit, dispatch }, payload) {
  const product = payload;
  product.uid = uid();
  commit('addProduct', { product });
  await dispatch('updateTotalPrice');
}

export async function updateCurrentProduct({ commit, dispatch, rootState }) {
  if (rootState.product.current) {
    const product = rootState.product.current;
    if (product.uid) {
      commit('updateProduct', { product });
      commit('product/updateCurrentProduct', { product }, { root: true });
      await dispatch('updateTotalPrice');
    }
  }
}

export async function removeProduct({ commit, dispatch }, { product }) {
  commit('removeProduct', { product });
  await dispatch('updateTotalPrice');
}

export async function updateTotalPrice({ commit, state }) {
  let totalPrice = 0;
  state.products.forEach((product) => {
    totalPrice += product.totalPrice;
  });
  commit('updateTotalPrice', { totalPrice });
}

export async function updateOrderLocationFromStorage({ commit }) {
  if (LocalStorage.has('location')) {
    commit('updateLocation', { location: LocalStorage.getItem('location') });
  }
}

export async function storeOrderLocation({ state }) {
  if (state.location) {
    LocalStorage.set('location', state.location);
  }
}

export async function flush({ commit }) {
  commit('flush');
}
